import './TechStack.css';

// Official technology logos loaded from the devicon CDN
const stack = [
  { name: 'PHP', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg' },
  { name: 'Node.js', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg' },
  { name: 'HTML5', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg' },
  { name: 'CSS3', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg' },
  { name: 'JavaScript', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg' },
  { name: 'React', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
  { name: 'Photoshop', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/photoshop/photoshop-plain.svg' },
  { name: 'Illustrator', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/illustrator/illustrator-plain.svg' },
  { name: 'Meta', src: 'https://cdn.simpleicons.org/meta/0668E1' },
  { name: 'Claude', src: 'https://cdn.simpleicons.org/claude/D97757' },
  { name: 'Lovable', src: 'https://cdn.simpleicons.org/lovable' },
  { name: 'WordPress', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/wordpress/wordpress-plain.svg' },
  { name: 'Shopify', src: 'https://cdn.simpleicons.org/shopify/95BF47' },
];

// Layered stack — organised the way our actual project work is organised:
// what we build with, design with, market with, and automate with.
const layers = [
  {
    n: '01',
    title: 'Web & App Development',
    items: [
      { icon: '⚛️', name: 'React / Next.js', desc: 'Fast, modern frontend builds' },
      { icon: '🐍', name: 'FastAPI / Node.js', desc: 'Scalable backend systems' },
      { icon: '📝', name: 'WordPress', desc: 'CMS-based business sites' },
      { icon: '🛍️', name: 'Shopify', desc: 'eCommerce storefronts for clients' },
      { icon: '🗄️', name: 'Supabase', desc: 'Realtime database & auth for custom apps' },
    ],
  },
  {
    n: '02',
    title: 'Design & Creative',
    items: [
      { icon: '🎨', name: 'Figma', desc: 'UI/UX design & prototyping' },
      { icon: '🖌️', name: 'Photoshop / Illustrator', desc: 'Brand creatives & print design' },
      { icon: '🎬', name: 'Premiere Pro / CapCut', desc: 'Video editing & reels' },
    ],
  },
  {
    n: '03',
    title: 'Digital Marketing & Ads',
    items: [
      { icon: '📢', name: 'Google Ads', desc: 'Search & display campaigns' },
      { icon: '📸', name: 'Meta Ads Manager', desc: 'Facebook & Instagram campaigns' },
      { icon: '🔍', name: 'SEMrush / Ahrefs', desc: 'SEO & keyword research' },
    ],
  },
  {
    n: '04',
    title: 'AI & Automation',
    items: [
      { icon: '🤖', name: 'OpenAI / GPT APIs', desc: 'Chatbots & content generation' },
      { icon: '✨', name: 'Custom AI Pipelines', desc: 'Face-replacement, personalisation engines' },
      { icon: '⚙️', name: 'Workflow Automation', desc: 'Automating repetitive client processes' },
    ],
  },
  {
    n: '05',
    title: 'CRM & Communication',
    items: [
      { icon: '💬', name: 'WhatsApp Cloud API', desc: 'Automated lead capture & routing' },
      { icon: '📇', name: 'Custom CRM', desc: 'React + Supabase lead management dashboards' },
    ],
  },
  {
    n: '06',
    title: 'Analytics & Hosting',
    items: [
      { icon: '📈', name: 'Google Analytics 4', desc: 'Behaviour, funnels, ecommerce events' },
      { icon: '🏷️', name: 'Google Tag Manager', desc: 'Centralised tag management' },
      { icon: '☁️', name: 'Hostingraja cPanel', desc: 'Deployment & hosting infrastructure' },
    ],
  },
];

export default function TechStack() {
  return (
    <section id="tech-stack" className="tech-section">
      <div className="tech-header reveal">
        <span className="section-label">Tech Stack</span>
        <h2 className="section-title">Our <em>Platforms</em></h2>
        <p className="section-sub">We build with modern, proven technologies that power fast, scalable, and reliable digital products.</p>
      </div>
      <div className="tech-marquee reveal">
        <div className="tech-track">
          {[...stack, ...stack].map((t, i) => (
            <div key={t.name + i} className="tech-item" title={t.name}>
              <img
                src={t.src}
                alt={t.name}
                loading="lazy"
                onError={(e) => { e.currentTarget.parentElement.style.display = 'none'; }}
              />
              <span>{t.name}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="tech-layers">
        {layers.map((layer) => (
          <div className="tech-layer reveal" key={layer.n}>
            <div className="tech-layer-head">
              <span className="tech-layer-num">Layer {layer.n}</span>
              <h3>{layer.title}</h3>
            </div>
            <div className="tech-layer-grid">
              {layer.items.map((item) => (
                <div className="tech-card" key={item.name}>
                  <span className="tech-card-icon">{item.icon}</span>
                  <div>
                    <h4>{item.name}</h4>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
